export default __webpack_public_path__ + "static/media/instagram.83e2e143.svg";